<template>
  <picker-field
    :label="label"
    :display="display"
    :value="value"
    :title="title"
    ref="picker"
    @open="onSearch"
  >
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.display"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.display}}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField
  },
  props: {
    label: String,
    value: String,
    title: String,
    url: String,
    params: {
      type: Object,
      default() {
        return {}
      }
    },
    autoload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      display: null,
      items: []
    };
  },
  watch: {
    value() {
      var me = this,
        val = me.value;
      // 对于给定初始value值的情况，加载数据并显示出display值
      me.$nextTick(function() {
        if (!me.display && me.autoload) {
          me.$loading({
            url: me.url,
            params: me.params
          }).then(function(res) {
            if (res.success) {
              if (res.data) {
                var item = res.data.find(d => d.value == val);
                if (item) {
                  me.display = item.display;
                }
              }
            } else {
              me.$weui.topTips(res.message, 2000);
            }
          });
        }
      });
    }
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.value);
      me.display = item.display;
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this;
      me.$loading({
        url: me.url,
        params: me.params
      }).then(function(res) {
        if (res.success) {
          me.items = res.data;
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    }
  }
};
</script>